






































import { Component } from 'vue-property-decorator'
import { HsComponent } from '@hds/help-common/src/components/hs-components'
import myMenuService from '~/service/my-menu-service'
import HsConfirmDialog from '~/components/ui/HsConfirmDialog.vue'

@Component({
  components: { HsConfirmDialog },
  data() {
    return {}
  },
  middleware: async (ctx) => {
    // todo: middleware
  },
  validate: async (ctx) => {
    // todo: validate
    return true
  },
  asyncData: async (ctx) => {
    // todo: asyncData
  },
})
/**
 * @vuese
 * @group component group
 * component description
 */
export default class extends HsComponent {
  // #region variables
  deleteConfirmDialog: boolean = false
  deleteTargetFavItem: number = null

  get myFavItems() {
    return this.$ustra.hs.store.menuData.myMenus
  }

  async deleteFavItem(menuId) {
    this.$ustra.hs.store.menuData.removeMyMenu(menuId)
    await myMenuService.removeMyMenu(menuId)
  }

  // #endregion
  // #region hooks
  // #endregion
  // #region methods

  // #endregion
  // #region watches
  // #endregion
}
